import { Component as ComponentContainer } from '@styles/layout';
import { Name } from '@model/iceberg';
import { HolidaysCallToBook } from '@components/call-to-book/HolidaysCallToBook';

interface HolidaysCallToBookProps {
  destination: Name;
}

export const HolidaysCallToBookContainer = (props: HolidaysCallToBookProps) => {
  const { destination } = props;

  return (
    <ComponentContainer>
      <HolidaysCallToBook {...props} destination={destination?.display} />
    </ComponentContainer>
  );
  return null;
};
